import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import logoImage from '../assets/animlearn-logo.png';
import './UnifiedHeader.css';

const UnifiedHeader = ({
  onOpenMenu,
  subRow,
  rightContent,
}) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 40);
      if (y > lastY.current && y > 80) setHidden(true);
      else setHidden(false);
      lastY.current = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`unified-header${scrolled ? ' header-scrolled' : ''}${hidden ? ' header-hidden' : ''}`}>
      <div className="header-container">
        <div className="header-left">
          <div className="logo" onClick={() => navigate('/')}>
            <img src={logoImage} alt="AnimLearn" className="logo-image" />
          </div>
        </div>

        <div className="header-right">
          {rightContent}
          <LanguageSwitcher />
          {onOpenMenu && (
            <button onClick={onOpenMenu} className="btn-menu" aria-label="Open menu">
              <Menu size={24} />
            </button>
          )}
        </div>
      </div>
      {subRow && (
        <div className="header-subrow">
          <div className="header-subrow-inner">
            {subRow}
          </div>
        </div>
      )}
    </header>
  );
};

export default UnifiedHeader;
